import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';
import { AuthProvider } from '@sdk/authentication/AuthContext';

import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import TimesheetHistory from '@web/timeClock/TimesheetHistory/TimesheetHistory';

const TimesheetHistoryAngular = ({ historyItems, back, Authentication, PersonaCollection }) => {
  return (
    <AuthProvider currentUser={Authentication.user}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <PersonaCollectionContext.Provider value={PersonaCollection}>
          <TimesheetHistory historyItems={historyItems} back={back} />
        </PersonaCollectionContext.Provider>
      </UserOrgSettingsProvider>
    </AuthProvider>
  );
};

export default {
  ReactComponent: TimesheetHistoryAngular,
  bindings: {
    historyItems: '<',
    back: '&',
  },
  dependencies: ['Authentication', 'PersonaCollection'],
};
